import { render, staticRenderFns } from "./AtomSquare.vue?vue&type=template&id=84393b34&"
import script from "./AtomSquare.vue?vue&type=script&lang=js&"
export * from "./AtomSquare.vue?vue&type=script&lang=js&"
import style0 from "./AtomSquare.vue?vue&type=style&index=0&id=84393b34&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports